var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArsenal({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 73,
    height: 73,
    viewBox: "0 0 73 73",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Ellipse_410",
    x: 0,
    y: 0,
    width: 73,
    height: 73,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_29024",
    "data-name": "Group 29024",
    transform: "translate(-4265 4996)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 4265, -4996)",
    filter: "url(#Ellipse_410)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_410-2",
    "data-name": "Ellipse 410",
    cx: 27.5,
    cy: 27.5,
    r: 27.5,
    transform: "translate(9 6)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "icons8-arsenal-fc",
    transform: "translate(4282 -4982)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_50617",
    "data-name": "Path 50617",
    d: "M32.646,5.833l-.033-.118-.106-.061C29.336,3.824,23.282,3,20,3s-9.344.824-12.512,2.653l-.106.061-.033.118C3.533,19.259,7.862,29.55,19.86,35.6l.135.068.135-.068C32.141,29.545,36.469,19.254,32.646,5.833Z",
    fill: "#9c824a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50618",
    "data-name": "Path 50618",
    d: "M13.506,13.5a1.914,1.914,0,0,0,.429-.03c-.039-.159-.079-.378-.16-.723C13.654,13.1,13.587,13.285,13.506,13.5Zm8.653-.438c.082,0,.148-.033.148-.159a.855.855,0,0,0-.039-.186c-.054-.222-.175-.189-.229-.189-.16,0-.32.189-.32.628v.1a3.525,3.525,0,0,1,.44-.159Zm-.254,1a.623.623,0,0,0,.522.408,1.183,1.183,0,0,0,.82-.408l.347.438v-.534s-.012-.282-.012-.534C23.272,13.568,22.186,13.976,21.905,14.072Z",
    transform: "translate(-1.669 -2.119)",
    fill: "#023474"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50619",
    "data-name": "Path 50619",
    d: "M32.1,6.725l-.041-.142-.136-.055a29.507,29.507,0,0,0-11.668-2.35A29.532,29.532,0,0,0,8.577,6.527l-.136.056L8.4,6.725c-3.59,12.661.571,22.664,11.717,28.166l.133.065.133-.065C31.527,29.389,35.687,19.386,32.1,6.725ZM27.319,13.5a.742.742,0,0,1-.079-.156,1.317,1.317,0,0,1-.751.249,1.15,1.15,0,0,1-1.128-.628c.012.093.054.408.066.534H23.939a8.865,8.865,0,0,0,.04-1.384l-.04-.942c-.015-.249-.136-.249-.2-.219a.194.194,0,0,0-.175.063.289.289,0,0,0-.066.189s.027.909.027.879a8,8,0,0,0,.148,1.413H22.126c.015-.1.042-.441.042-.567a1.739,1.739,0,0,1-1.382.6,1.806,1.806,0,0,1-1.639-.909,1.584,1.584,0,0,1-1.569.909,2.741,2.741,0,0,1-1.222-.282l.027-1.317a1.737,1.737,0,0,0,1.18.69c.148,0,.311-.033.323-.126,0-.063,0-.093-.2-.219l-.576-.285a1,1,0,0,1-.67-.972.485.485,0,0,0-.389.189,1.218,1.218,0,0,0-.284.846,7.826,7.826,0,0,0,.015,1.447H12.854l-.024-.219a4.956,4.956,0,0,0-.124-.693c-.241.033-.763.033-.965.033a5.534,5.534,0,0,0-.214.879H10.064s.109-.189.163-.315c.416-.909.845-2.2,1.153-3.045a2.248,2.248,0,0,0,.163-.912,1.266,1.266,0,0,0-.054-.219l1.877-.282.658,2.953c.1.375.215.846.323,1.195.027-.252.039-.534.054-.786v-.063l.027-.5a5.041,5.041,0,0,0-.082-1.38l1.328-.063c.027.063.054.219.069.252a1.123,1.123,0,0,1,1.1-.348l-.012.285c.079-.063.16-.126.254-.189a2.112,2.112,0,0,1,.966-.219,2.058,2.058,0,0,1,.887.156l-.027,1a1.912,1.912,0,0,0-.845-.282c-.175,0-.308.063-.323.126,0,.03.015.06.148.124h.027l.565.285a1.191,1.191,0,0,1,.467.312,1.711,1.711,0,0,1,1.732-1.758,1.738,1.738,0,0,1,.911.252,1.575,1.575,0,0,1,.565.909,9.428,9.428,0,0,0-.148-1.069l1.234.063.054.126c.015.033.027.063.042.1a1.446,1.446,0,0,1,.8-.252,1.063,1.063,0,0,1,1.114,1.1l.042,1.038v.03a1.465,1.465,0,0,1,.817-.786,2.987,2.987,0,0,1,.766-.219.353.353,0,0,0-.366-.189,1.3,1.3,0,0,0-.709.222l-.323.186L25.4,10.2a4.273,4.273,0,0,1,1.02-.126c1.21,0,1.759.438,1.841,1.443l.051.63a3.393,3.393,0,0,0,.2,1.035l.054.126v-.03a9.892,9.892,0,0,0-.067-1.132l-.217-1.98a10.1,10.1,0,0,0-.254-1.413l1.421.252.39,3.078a8.328,8.328,0,0,0,.241,1.413H27.319v0Z",
    transform: "translate(-0.254 -0.262)",
    fill: "#023474"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50620",
    "data-name": "Path 50620",
    d: "M32.537,14.389s-.015-.126-.027-.282c-.4.126-.443.315-.456.441a.3.3,0,0,0,.32.312,1.576,1.576,0,0,0,.187-.063c-.012-.093-.012-.186-.024-.282v-.125Z",
    transform: "translate(-5.792 -2.469)",
    fill: "#023474"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50621",
    "data-name": "Path 50621",
    d: "M30.784,6.026l-.039-.153L30.6,5.817a28.114,28.114,0,0,0-9.559-1.653h-.567a28.144,28.144,0,0,0-9.562,1.653l-.148.054-.039.153c-3.38,13.391-.288,22.532,9.73,28.751l.3.177.3-.177C31.074,28.558,34.164,19.417,30.784,6.026ZM27.822,13.5l-.012-.02a.562.562,0,0,1-.066-.136,1.344,1.344,0,0,1-1.573-.01.985.985,0,0,1-.306-.369c.012.093.054.408.066.534H24.442a5.313,5.313,0,0,0,.046-.656c0-.124,0-.25,0-.373,0-.062,0-.117,0-.177s0-.122,0-.177l-.04-.942c-.015-.249-.136-.249-.2-.219a.194.194,0,0,0-.175.063.289.289,0,0,0-.066.189s.011.355.019.614c0,.052,0,.1,0,.141,0,.081,0,.132,0,.124,0,.054,0,.116.008.174a7.347,7.347,0,0,0,.141,1.239H22.63c0-.024.009-.064.013-.111.014-.144.03-.361.03-.456a1.739,1.739,0,0,1-1.382.6,1.859,1.859,0,0,1-1.434-.638,1.56,1.56,0,0,1-.2-.271,1.012,1.012,0,0,1-.162.3,1.772,1.772,0,0,1-1.407.607,2.741,2.741,0,0,1-1.222-.282h0l.027-1.317a1.737,1.737,0,0,0,1.18.69c.148,0,.311-.033.323-.126a.114.114,0,0,0-.025-.086.773.773,0,0,0-.177-.133l-.576-.285a1.024,1.024,0,0,1-.652-.849.972.972,0,0,1-.018-.123.485.485,0,0,0-.389.189.724.724,0,0,0-.2.328,2.146,2.146,0,0,0-.086.518c-.012.174-.025.418-.026.677a5.581,5.581,0,0,0,.041.769H13.359l-.024-.219c0-.047-.016-.11-.023-.167-.013-.094-.028-.184-.049-.287-.016-.082-.033-.165-.051-.24-.241.033-.763.033-.965.033a6.394,6.394,0,0,0-.183.689c-.014.071-.025.135-.032.191H10.568l.018-.032c.033-.059.1-.189.145-.284.208-.454.419-1,.617-1.546s.382-1.076.536-1.5a2.79,2.79,0,0,0,.167-.792c0-.05,0-.089,0-.121s-.009-.044-.014-.066A1.256,1.256,0,0,0,11.992,9h0l1.877-.282.394,1.772.263,1.181c.1.375.215.846.323,1.195.014-.126.023-.26.032-.393s.015-.268.023-.394V12.02h0l.027-.5c.007-.117.011-.24.012-.362a5.5,5.5,0,0,0-.037-.711,2.7,2.7,0,0,0-.056-.308l1.328-.063c.027.063.054.219.069.252a1.3,1.3,0,0,1,.589-.35,1.183,1.183,0,0,1,.509,0l-.012.285c.079-.063.16-.126.254-.189a2.112,2.112,0,0,1,.966-.219,2.058,2.058,0,0,1,.887.156h0l-.027,1a1.912,1.912,0,0,0-.845-.282c-.175,0-.308.063-.323.126,0,.021.023.047.074.079a.465.465,0,0,0,.074.044h.027l.338.171.226.114a1.192,1.192,0,0,1,.467.312,2.1,2.1,0,0,1,.134-.7,1.545,1.545,0,0,1,.364-.556,1.77,1.77,0,0,1,1.234-.5,1.738,1.738,0,0,1,.911.252,1.454,1.454,0,0,1,.215.2,1.592,1.592,0,0,1,.349.7c-.009-.164-.058-.558-.1-.838-.016-.093-.031-.174-.044-.229h0l1.234.063.054.126c.015.033.027.063.042.1a1.446,1.446,0,0,1,.8-.252,1.037,1.037,0,0,1,.946.533,1.213,1.213,0,0,1,.167.566l.042,1.038h0v.03a1.465,1.465,0,0,1,.817-.786,2.979,2.979,0,0,1,.766-.219.352.352,0,0,0-.365-.189,1.3,1.3,0,0,0-.709.222l-.323.186-.047-.645L25.9,10.2h0a4.273,4.273,0,0,1,1.02-.126c.958,0,1.5.28,1.722.894a2.069,2.069,0,0,1,.119.551l.051.63a4.6,4.6,0,0,0,.131.834,1.746,1.746,0,0,0,.072.2l.054.126v-.03c0-.34-.022-.654-.051-.95-.005-.059-.009-.123-.016-.18l-.109-.99-.109-.99c-.038-.306-.094-.719-.17-1.078-.026-.12-.053-.233-.083-.336l1.421.252.26,2.052.13,1.026c.005.054.013.116.019.174a7.7,7.7,0,0,0,.222,1.239Z",
    transform: "translate(-0.758 -0.259)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50622",
    "data-name": "Path 50622",
    d: "M13.4,21.029h-.1v.014a1.2,1.2,0,0,0-.88.946.555.555,0,0,0-.134-.03.718.718,0,0,0,0,1.428.569.569,0,0,0,.18-.04,1.125,1.125,0,0,0,.834.813v.013h2.751a5.059,5.059,0,0,1,2.085-3.144Z",
    transform: "translate(-1.254 -4.008)",
    fill: "#9c824a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50623",
    "data-name": "Path 50623",
    d: "M22.468,29.992a5.1,5.1,0,1,1,5.133-5.1A5.123,5.123,0,0,1,22.468,29.992Z",
    transform: "translate(-2.521 -3.731)",
    fill: "#9c824a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50624",
    "data-name": "Path 50624",
    d: "M22.44,19.85a5.008,5.008,0,1,1-5.032,5.008A5.021,5.021,0,0,1,22.44,19.85m0-.194a5.2,5.2,0,1,0,5.23,5.2,5.221,5.221,0,0,0-5.23-5.2Z",
    transform: "translate(-2.493 -3.703)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50625",
    "data-name": "Path 50625",
    d: "M26.941,25.216a4.179,4.179,0,0,1-8.359,0h0a4.179,4.179,0,0,1,8.359,0Z",
    transform: "translate(-2.797 -4.014)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50626",
    "data-name": "Path 50626",
    d: "M26.736,25.232a3.921,3.921,0,0,1-7.842,0h0a3.921,3.921,0,0,1,7.842,0Z",
    transform: "translate(-2.866 -4.076)",
    fill: "#9c824a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50627",
    "data-name": "Path 50627",
    d: "M22.5,28.089a1.914,1.914,0,0,1-.495-.309l-.074.089-.062-.1L19.822,29.1l.085.1a3.818,3.818,0,0,0,2.529,1.428l.133.017.006-2.445V28.12Z",
    transform: "translate(-3.073 -5.507)",
    fill: "#ef0107"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50628",
    "data-name": "Path 50628",
    d: "M25.208,27.457l-.062.1-.072-.091a1.977,1.977,0,0,1-.5.307l-.075.03,0,2.526.133-.017a3.819,3.819,0,0,0,2.529-1.429l.085-.1Zm.467-.869h-.006l1.995,1.284a3.746,3.746,0,0,0,.317-1.56Z",
    transform: "translate(-4.113 -5.182)",
    fill: "#db0007"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50629",
    "data-name": "Path 50629",
    d: "M26.014,26.52c.009-.036.006-.069.021-.174l2.275-.294a.942.942,0,0,1,0,.192l-2.3.276Z",
    transform: "translate(-4.449 -5.125)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50630",
    "data-name": "Path 50630",
    d: "M28.027,20.986,37.981,21,37.6,23.3l-7.724.378a5.263,5.263,0,0,0-1.849-2.695Z",
    transform: "translate(-4.897 -3.998)",
    fill: "#9c824a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50631",
    "data-name": "Path 50631",
    d: "M30.343,24.2h2.748c-.09.312-.154.6-.558.738a13.512,13.512,0,0,1-1.937.408,7.422,7.422,0,0,0-.253-1.146Z",
    transform: "translate(-5.412 -4.714)",
    fill: "#9c824a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50632",
    "data-name": "Path 50632",
    d: "M19.648,11.553a2.5,2.5,0,0,0-.658-.093,2.061,2.061,0,0,0-.845.189.974.974,0,0,0-.522.723.742.742,0,0,0,.537.783c.226.126.443.252.576.315.175.093.335.189.323.408s-.217.378-.552.378a1.682,1.682,0,0,1-.966-.441l-.012.66a2.341,2.341,0,0,0,.992.189c.615,0,1.382-.282,1.394-.975a.885.885,0,0,0-.588-.846c-.229-.1-.459-.222-.564-.252-.109-.063-.323-.126-.308-.378.024-.219.281-.315.549-.315a1.358,1.358,0,0,1,.631.159m-5.5-1.666-1.424.189a2.6,2.6,0,0,1-.175,1.006c-.292.846-.775,2.259-1.153,3.079h.887a4.293,4.293,0,0,1,.254-.879l1.316-.033a7.473,7.473,0,0,1,.16.912H15.2a12.826,12.826,0,0,1-.456-1.572l-.6-2.7Zm-1.425,2.857.645-1.852.39,1.821m3.8-1.665-.027.63a.811.811,0,0,0-.7.249,1.4,1.4,0,0,0-.335.975,10.194,10.194,0,0,0-.015,1.258h-1a9,9,0,0,0,.106-1.227l.027-.5a5.068,5.068,0,0,0-.039-1.195l.887-.03a1.7,1.7,0,0,1,.051.564c.388-.6.765-.722,1.046-.722M30.2,10.581l-.915-.159a10.938,10.938,0,0,1,.175,1.1l.215,1.978a8.635,8.635,0,0,1,.069,1.164h.992a7.532,7.532,0,0,1-.175-1.164M26.1,14.664c-.051-.378-.079-.756-.093-1.164l-.039-1.035a.825.825,0,0,0-.887-.879,1.142,1.142,0,0,0-.939.471,2.286,2.286,0,0,0-.109-.471l-.8-.033a8.072,8.072,0,0,1,.106,1.161l.015.786a11.2,11.2,0,0,1-.027,1.164h1c-.051-.378-.079-.756-.093-1.164l-.027-.879a.5.5,0,0,1,.471-.534c.281,0,.416.189.429.471l.042.942a11.287,11.287,0,0,1-.015,1.164m4.107,0a3.845,3.845,0,0,1-.214-1.1l-.054-.627c-.054-.753-.374-1.258-1.611-1.258a3.667,3.667,0,0,0-.775.093l.039.567a1.546,1.546,0,0,1,.833-.282.587.587,0,0,1,.642.627,2.752,2.752,0,0,0-.953.252,1.012,1.012,0,0,0-.724.972.886.886,0,0,0,1.008.819,1.1,1.1,0,0,0,.857-.378,1.707,1.707,0,0,0,.109.315Zm-1.464-.408a.5.5,0,0,1-.549-.5c0-.345.214-.627.9-.723l.04.534c.015.189.015.315.042.471a.681.681,0,0,1-.432.222M22.4,11.649a1.342,1.342,0,0,0-.778-.222,1.509,1.509,0,0,0-1.5,1.665,1.533,1.533,0,0,0,1.611,1.6,1.582,1.582,0,0,0,1.207-.5l-.2-.285a1.145,1.145,0,0,1-.778.315.957.957,0,0,1-.83-.753l1.822-.66a1.543,1.543,0,0,0-.549-1.16Zm-.631,1.161-.724.282a3.324,3.324,0,0,1-.027-.408c0-.723.4-.849.537-.849a.422.422,0,0,1,.471.348c.079.282.052.534-.256.627",
    transform: "translate(-1.197 -1.643)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50633",
    "data-name": "Path 50633",
    d: "M24.6,10.86a.824.824,0,0,1,.039.186c0,.126-.066.159-.148.159v.03a3.525,3.525,0,0,0-.44.159v-.1c0-.438.16-.628.32-.628C24.425,10.671,24.545,10.638,24.6,10.86ZM24,16.133a5.306,5.306,0,0,1,2.935.911l7.747.009A38.537,38.537,0,0,0,33.41,5.785l-.04-.159-.155-.054A29.02,29.02,0,0,0,24,4.157l0,5.722a1.77,1.77,0,0,1,.422-.058,1.738,1.738,0,0,1,.911.252,1.575,1.575,0,0,1,.565.909,9.428,9.428,0,0,0-.148-1.069l1.234.063.054.126c.015.033.027.063.042.1a1.446,1.446,0,0,1,.8-.252A1.063,1.063,0,0,1,29,11.046l.042,1.038v.03a1.465,1.465,0,0,1,.817-.786,2.987,2.987,0,0,1,.766-.219.353.353,0,0,0-.366-.189,1.3,1.3,0,0,0-.709.222l-.323.186L29.146,10.2a4.273,4.273,0,0,1,1.02-.126c1.21,0,1.759.438,1.841,1.443l.051.63a3.393,3.393,0,0,0,.2,1.035l.054.126v-.03a9.892,9.892,0,0,0-.067-1.132l-.217-1.98a10.1,10.1,0,0,0-.254-1.413l1.421.252.39,3.078a8.327,8.327,0,0,0,.241,1.413H31.065a.742.742,0,0,1-.079-.156,1.317,1.317,0,0,1-.751.249,1.15,1.15,0,0,1-1.128-.628c.012.093.054.408.066.534H27.685a8.866,8.866,0,0,0,.04-1.384l-.04-.942c-.015-.249-.136-.249-.2-.219a.194.194,0,0,0-.175.063.289.289,0,0,0-.066.189s.027.909.027.879a8,8,0,0,0,.148,1.413H25.872c.015-.1.042-.441.042-.567a1.739,1.739,0,0,1-1.382.6A2.122,2.122,0,0,1,24,13.452Zm.758-3.515a1.183,1.183,0,0,0,.82-.408l.347.438v-.534s-.012-.282-.012-.534c-.311.126-1.4.534-1.677.63A.622.622,0,0,0,24.76,12.618Zm7.075,7.408a.858.858,0,0,1-.53.589,15.513,15.513,0,0,1-2.058.493c.006.1.016.2.016.306A5.3,5.3,0,0,1,24,26.7l0,8.258c5.889-3.71,9.33-8.684,10.377-15.051ZM30.719,11.9c-.4.126-.443.315-.456.441a.3.3,0,0,0,.32.312,1.577,1.577,0,0,0,.187-.063c-.012-.093-.012-.186-.024-.282v-.125S30.73,12.051,30.719,11.9Z",
    transform: "translate(-4.001 -0.257)",
    fill: "#db0007"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50634",
    "data-name": "Path 50634",
    d: "M16.754,29.8a12.97,12.97,0,0,1-5.365,1.87l-.438-.66a13.31,13.31,0,0,0,4.987-3.139,5.248,5.248,0,0,0,.815,1.929Z",
    transform: "translate(-1.101 -5.53)",
    fill: "#9c824a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50635",
    "data-name": "Path 50635",
    d: "M17.421,26.6l-.017.012a11.849,11.849,0,0,1-4.023,1.635,22.609,22.609,0,0,0,8.261,8.626V28.618l-.055,0A5.306,5.306,0,0,1,17.421,26.6ZM13.906,13.537l-.16-.723-.268.754A1.5,1.5,0,0,0,13.906,13.537Z",
    transform: "translate(-1.641 -2.182)",
    fill: "#ef0107"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50636",
    "data-name": "Path 50636",
    d: "M18.752,10.733c-.175,0-.308.063-.323.126,0,.03.015.06.148.124H18.6l.565.285a1.191,1.191,0,0,1,.467.312,1.77,1.77,0,0,1,.5-1.254,1.717,1.717,0,0,1,.808-.444V4.157a28.976,28.976,0,0,0-9.207,1.415l-.155.054-.04.159C9.631,13.444,9.791,19.807,12.034,25a13.974,13.974,0,0,0,1.284-.7c.1-.06.192-.119.288-.182a12.068,12.068,0,0,0,.987-.7l.039-.029a10.855,10.855,0,0,0,1.006-.922l.037-.038a5.261,5.261,0,0,1-.1-1.016,5.163,5.163,0,0,1,.068-.8H12.983l-.194-.013v-.04a1.317,1.317,0,0,1-.744-.721c-.023,0-.043-.011-.065-.013h-.009a.747.747,0,0,1-.131-.029,1.05,1.05,0,0,1-.132-.029.9.9,0,0,1-.576-.851.877.877,0,0,1,.84-.908h0a1.5,1.5,0,0,1,.62-.781.784.784,0,0,1,.115-.056c.027-.012.053-.03.081-.04l.194-.054h4.864a5.3,5.3,0,0,1,3.037-.955c.019,0,.037,0,.056,0v-2.68a1.7,1.7,0,0,1-1.1-.836,1.584,1.584,0,0,1-1.569.909,2.741,2.741,0,0,1-1.222-.282l.027-1.317a1.737,1.737,0,0,0,1.18.69c.148,0,.311-.033.323-.126,0-.063,0-.093-.2-.219l-.576-.285a1,1,0,0,1-.67-.972.485.485,0,0,0-.389.189,1.218,1.218,0,0,0-.284.846A7.826,7.826,0,0,0,16.47,13.5H13.544l-.024-.219a4.956,4.956,0,0,0-.124-.693c-.241.033-.763.033-.965.033a5.534,5.534,0,0,0-.214.879H10.754s.109-.189.163-.315c.416-.909.845-2.2,1.153-3.045a2.248,2.248,0,0,0,.163-.912A1.265,1.265,0,0,0,12.177,9l1.877-.282.658,2.953c.1.375.215.846.323,1.195.027-.252.039-.534.054-.786v-.063l.027-.5a5.041,5.041,0,0,0-.082-1.38l1.328-.063c.027.063.054.219.069.252a1.123,1.123,0,0,1,1.1-.348l-.012.285c.079-.063.16-.126.254-.189a2.112,2.112,0,0,1,.966-.219,2.058,2.058,0,0,1,.887.156l-.027,1A1.93,1.93,0,0,0,18.752,10.733Z",
    transform: "translate(-0.938 -0.257)",
    fill: "#ef0107"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50637",
    "data-name": "Path 50637",
    d: "M25.1,25.881a1.636,1.636,0,0,1-3.271,0v0a1.636,1.636,0,0,1,3.271,0v0Z",
    transform: "translate(-3.519 -4.725)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50638",
    "data-name": "Path 50638",
    d: "M24.964,25.936a1.442,1.442,0,0,1-2.884,0v0a1.442,1.442,0,0,1,2.884,0v0Z",
    transform: "translate(-3.575 -4.78)",
    fill: "#9c824a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50639",
    "data-name": "Path 50639",
    d: "M24.465,26.135a.741.741,0,0,1-1.482,0h0a.741.741,0,0,1,1.482,0Z",
    transform: "translate(-3.775 -4.979)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50640",
    "data-name": "Path 50640",
    d: "M24.318,26.193a.537.537,0,0,1-1.075,0h0a.537.537,0,0,1,1.075,0Z",
    transform: "translate(-3.833 -5.037)",
    fill: "#9c824a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50641",
    "data-name": "Path 50641",
    d: "M23.209,21.218h1.116v2.59H23.209Z",
    transform: "translate(-3.826 -4.05)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50642",
    "data-name": "Path 50642",
    d: "M23.434,20.74H24.2v3.292h-.769Z",
    transform: "translate(-3.876 -3.944)",
    fill: "#9c824a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50643",
    "data-name": "Path 50643",
    d: "M25.968,23.1l.61.93-2.185,1.411-.607-.931Zm-4.676,2.737.6.936-2.2,1.386-.6-.939Z",
    transform: "translate(-2.91 -4.468)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50644",
    "data-name": "Path 50644",
    d: "M21.6,26.546l.413.649-2.793,1.761-.414-.649Z",
    transform: "translate(-2.848 -5.234)",
    fill: "#9c824a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50645",
    "data-name": "Path 50645",
    d: "M19.216,23.754l.613-.927,2.178,1.416-.613.93Z",
    transform: "translate(-2.938 -4.408)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50646",
    "data-name": "Path 50646",
    d: "M18.956,23.426l.423-.642,2.766,1.8-.422.642Z",
    transform: "translate(-2.88 -4.398)",
    fill: "#9c824a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50647",
    "data-name": "Path 50647",
    d: "M25.195,27.55l.612-.93,2.179,1.419-.613.93Z",
    transform: "translate(-4.267 -5.251)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50648",
    "data-name": "Path 50648",
    d: "M24.925,26.433l.422-.642,2.767,1.8-.422.639Zm2.74-3.409.419.642-2.776,1.795-.42-.645Z",
    transform: "translate(-4.199 -4.451)",
    fill: "#9c824a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50649",
    "data-name": "Path 50649",
    d: "M23.209,28.256h1.116v2.59H23.209Z",
    transform: "translate(-3.826 -5.615)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50650",
    "data-name": "Path 50650",
    d: "M23.434,27.844H24.2v3.289h-.769Z",
    transform: "translate(-3.876 -5.523)",
    fill: "#9c824a"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArsenal);
export default __webpack_public_path__ + "static/media/arsenal.b496212db503035ecc6455363b6c4add.svg";
export { ForwardRef as ReactComponent };